/*--------------------------------------
	불러톡 — 웹서버 HTTP 통신 (ChatAjax)

	/ajax/chat/send · /ajax/chat/messages · /api/upload.
	상태는 메인 Chat(this.chat)이 보유하며, 소켓 emit 은 chat, 그리기는 chat.draw 에 위임.
--------------------------------------*/
import Util from '../../Common/Util';
export default class ChatAjax {
	/**
	 * @param chat 메인 Chat 인스턴스(상태 공유)
	 */
	constructor(chat){
		this.chat = chat;
	}

	/**
	 * 메세지를 DB 저장 후 소켓 전송.
	 * @param fileId 첨부파일 ID(없으면 텍스트)
	 */
	sendMessageToGo(fileId = null){
		const chat = this.chat;
		const $input = $('#sendmessagcont');
		const mcont = $input.val();
		$input.val('');
		chat.draw.autoGrow($input[0]); // 전송 후 한 줄 높이로 복귀

		if( !fileId && mcont.length < 1 ) return;
		chat.draw.hideTray(); // 관리자 답변 전송 → 트레이 숨김(회원이 다시 말하면 onRecvMsg 에서 재노출)
		// (전송중 표시 없음 — 전송 버튼이 <img> 이던 시절 src 를 로딩 GIF 로 바꾸던 코드가 있었으나,
		//  지금은 <button class="chat-input__send"> 이라 동작하지 않는 죽은 코드였다.)

		const reply = chat.replyTo;       // 답장 대상(있으면) — 캡처 후 즉시 모드 해제
		chat.draw.cancelReply();

		const sendData = {
			jobAct: 'personalmessagesending',
			sendernum: chat.myMbno,
			talkName: chat.talkName,
			mcont: mcont,
			roomno: chat.roomno,
			file_id: fileId,
			reply: reply ? JSON.stringify(reply) : '', // 답장 인용 스냅샷(서버가 저장 + body.reply 로 되돌려줌)
			memberofroom: Object.keys(chat.roomMembers).length,
			CurrentMember: chat.currentMember,
			CurrentmembersList: chat.currentMembersList,
		};

		$.post('/ajax/chat/send', sendData, function(data){
			// 발신자 없는 톡은 서버가 거부한다 (관리자 앱계정 미연결 — ChatMessageService::send)
			if( data && data.result === false ){
				$j.Ui.Toast.show(data.message || '톡을 보낼 수 없습니다', { type: 'error' });
				$input.val(mcont); // 쓴 글은 돌려준다
				return;
			}
			let id = parseInt(data.id);
			if( isNaN(id) ) id = 0;
			chat.socket.sendToNode({ msg: data.msg, body: data.body, id, file_id: fileId });
			chat.ajax.clearOpenerBadge(); // 관리자 답변 → 부모 방목록의 안읽음(1) 뱃지 제거
			// 관리자가 이 방에 답장하면 서버(send)가 방 전체 미읽음을 털므로, 화면의 안읽음 태그도 같이 지운다.
			//  조건은 서버의 isGuest 와 같다 — 방주인이 아닌 사람(=상담원)이 쓴 경우.
			if( chat.roomno != chat.myMbno ) chat.draw.clearUnreadMarks();
		}, 'json');
	}

	/**
	 * 관리자: 불러톡 메시지 소프트 삭제. 성공 시 화면을 '삭제된 메시지'로 교체.
	 * (권한/대상 검증은 서버 — 관리자가 보낸 메시지만 삭제됨)
	 * @param num g5_chat_messages.num
	 */
	deleteMessage(num){
		const chat = this.chat;
		num = parseInt(num) || 0;
		if( !num ) return;
		$.post('/adm/ajax/chat/message/delete', { num }, function(res){
			if( res && res.result ){
				chat.draw.markDeleted(num);
			} else {
				Util.swalert((res && res.message) || '삭제에 실패했습니다.');
			}
		}, 'json');
	}

	/**
	 * 안읽음 표시/해제 — 회원이 보낸 톡을 다시 안읽음으로 되돌리거나 읽음으로 되돌린다(관리자 전용).
	 * 원하는 상태를 명시해 보내고, 화면은 서버가 돌려준 상태로만 갱신한다
	 * (다른 상담원이 먼저 손댔거나 답장으로 털린 뒤여도 화면과 DB가 어긋나지 않는다).
	 * @param num g5_chat_messages.num
	 * @param on  true=안읽음으로, false=읽음으로
	 */
	setUnread(num, on){
		const chat = this.chat;
		num = parseInt(num) || 0;
		if( !num ) return;
		$.post('/adm/ajax/chat/message/unread', { num, unread: on ? 1 : 0 }, function(res){
			if( res && res.result ){
				const unread = (parseInt(res.unread) === 1);
				chat.draw.markUnread(num, unread);
				if( window.$j && $j.Ui && $j.Ui.Toast ) $j.Ui.Toast.show(unread ? '안읽음으로 표시했습니다' : '읽음으로 되돌렸습니다', { type: 'success' });
			} else {
				Util.swalert((res && res.message) || '처리에 실패했습니다.');
			}
		}, 'json');
	}

	/**
	 * 관리자 답변 전송 후, 방목록(부모 창)의 해당 방 안읽음 뱃지를 제거한다.
	 * 관리자 불러톡은 방목록에서 window.open 으로 뜬 별도 팝업이라, 답변해도 부모 창 뱃지가 갱신되지 않는다.
	 */
	clearOpenerBadge(){
		const chat = this.chat;
		if( !chat.isAdminPage ) return;              // 관리자 팝업에서만
		const opener = window.opener;
		if( !opener || opener.closed ) return;
		if( typeof opener.clearChatUnread === 'function' ) opener.clearChatUnread(chat.roomno);
	}

	/**
	 * 파일(이미지) 업로드 — 업로드 완료 후 각 파일을 메세지로 전송.
	 */
	startUpload(){
		const chat = this.chat;
		chat.uploadFormData.append('tag', 'talk');
		$.ajax({ // FormData 전송이라 $.post 가 아닌 $.ajax (processData/contentType false 필요)
			url: '/api/upload',
			type: 'POST',
			data: chat.uploadFormData,
			processData: false,
			contentType: false,
			success: function(list){
				$.each(list, function(i, row){ chat.ajax.sendMessageToGo(row.id); });
			},
		});
	}

	/**
	 * 번개 빠른답변 **그대로 보내기** — 서식글·이미지는 입력창에 담을 수 없어 이 경로로 나간다.
	 *
	 * 본문은 서버가 틀 번호로 찾는다(클라가 content_id 를 지목하지 않는다 — ChatMessageService::send).
	 * 이미지는 장당 한 건이라 여러 건이 돌아오고, 소켓에도 하나씩 흘린다.
	 */
	sendQuick(quickNum){
		const chat = this.chat;
		chat.draw.hideTray();
		$.post('/ajax/chat/send-quick', {
			sendernum: chat.myMbno,
			roomno   : chat.roomno,
			quick_num: quickNum,
		}, function(res){
			if( !res || res.result === false ){
				$j.Ui.Toast.show((res && res.message) || '톡을 보낼 수 없습니다', { type: 'error' });
				return;
			}
			(res.sent || []).forEach((m) => {
				let id = parseInt(m.id);
				if( isNaN(id) ) id = 0;
				chat.socket.sendToNode({ msg: m.msg, body: m.body, id, file_id: m.file_id || '' });
			});
			chat.ajax.clearOpenerBadge();
			if( chat.roomno != chat.myMbno ) chat.draw.clearUnreadMarks();
		}, 'json');
	}

	/**
	 * 자동완성 키워드(#) 목록 로딩 → 칩 렌더.
	 */
	getKeywords(){
		const chat = this.chat;
		$.get('/ajax/chat/keywords', {}, function(list){
			chat.draw.setQuickTemplates(list || []);
		}, 'json');
	}

	/**
	 * 대화목록 추가 로딩.
	 */
	getMoreTalk(){
		const chat = this.chat;
		const limit = 20;
		if( chat.ongetting == 1 ) return; // 가져오는 중이면 무시
		if( chat.firstRsno == 0 ) return; // 이미 다 가져왔으면 무시

		const isFirst = (chat.firstRsno == -1); // 최초 수신
		chat.ongetting = 1;

		const sendData = {
			rno: chat.roomno,        // 방번호(회원번호)
			offset: chat.firstRsno,  // 마지막 데이터값
			mb_no: chat.userNum,     // 대화자(관리자면 관리자 회원번호)
			limit: limit,
		};

		$.get('/ajax/chat/messages', sendData, function(list){ // 최신→과거 순 배열
			$('#firstContLoading').hide();
			if( list.length == 0 ) return;

			chat.draw.drawList(list);
			if( !chat.lastDate ) chat.lastDate = dayjs(list[0].sent_date).format('YYYY-MM-DD');
			chat.firstRsno = list[list.length - 1].num;

			if( list.length < limit ){ // 더 가져올 게 없음
				chat.firstRsno = 0;
				$('#content_list').prepend( chat.draw.dateLine(chat.firstDate) );
			}
			chat.ongetting = 0;

			if( isFirst ){
				chat.draw.scrollToBottom();            // 최초 수신 시 최신으로
				chat.draw.initObserver($('#top-observer')[0]);
				chat.draw.updateRecoTray();            // 마지막이 회원이면 추천답변 노출
			}
		}, 'json');
	}
}